import React, { useEffect, useMemo, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { storageService } from "services/storageService";
import {
  AppRole,
  hasModuleAccess,
  parseJwtPayload,
} from "util/moduleAccess";

interface ModuleProtectedRouteProps {
  requiredModule: string;
  fallbackPath?: string;
}

const ModuleProtectedRoute: React.FC<ModuleProtectedRouteProps> = ({
  requiredModule,
  fallbackPath = "/admin/profile",
}) => {
  const [accessTokenVersion, setAccessTokenVersion] = useState(0);

  useEffect(() => {
    const handleAuthTokenUpdated = () => {
      setAccessTokenVersion((prev) => prev + 1);
    };

    window.addEventListener("auth-token-updated", handleAuthTokenUpdated as EventListener);
    return () => {
      window.removeEventListener("auth-token-updated", handleAuthTokenUpdated as EventListener);
    };
  }, []);

  const token = useMemo(
    () => storageService.getItem("accessToken"),
    [accessTokenVersion],
  );
  const payload = parseJwtPayload(token);
  const storedUser = storageService.getItem("user");

  let currentRole: AppRole = undefined;
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser) as { role?: number | string };
      currentRole = parsedUser?.role;
    } catch {
      currentRole = undefined;
    }
  }

  if (hasModuleAccess(payload, requiredModule, currentRole)) {
    return <Outlet />;
  }

  return <Navigate to={fallbackPath} replace />;
};

export default ModuleProtectedRoute;
